import { render, staticRenderFns } from "./MergeWallets.vue?vue&type=template&id=1ca37ed0&scoped=true"
import script from "./MergeWallets.vue?vue&type=script&lang=js"
export * from "./MergeWallets.vue?vue&type=script&lang=js"
import style0 from "./MergeWallets.vue?vue&type=style&index=0&id=1ca37ed0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca37ed0",
  null
  
)

export default component.exports